/**
 * re-usable API functions
 */

import React from 'react';
import { createPortfolioMonitoringAPI } from './portfolio-monitoring';
import { createPrincipleInvestmentAPI } from './principal-investment';
import { createNoticeAPI } from './notices';
import { Backend } from '@hum/common/src/api/client';

export type CreateAPIOptions = {
  client: Backend;
};

export type API = ReturnType<typeof createAPI>;

export const createAPI = (options: CreateAPIOptions) => {
  return {
    portfolioMonitoring: createPortfolioMonitoringAPI(options),
    principalInvestment: createPrincipleInvestmentAPI(options),
    notices: createNoticeAPI(options),
  };
};

export const APIContext = React.createContext<API | null>(null);
